import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["enableStickyTop", "enableStickyColumns"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContext } from 'react';
import { TABLE_HEAD, TABLE_FOOT, TableSectionContext } from '../../utils/TableSectionContext';
import { TableContext } from '../../utils/TableContext';
var EMPTY_STICKY_COLUMNS = [];
export var useTableRow = function useTableRow(_ref) {
  var enableStickyTop = _ref.enableStickyTop,
      enableStickyColumns = _ref.enableStickyColumns,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(TableContext),
      _useContext$data = _useContext.data,
      stickyHead = _useContext$data.stickyHead,
      stickyHeadVisible = _useContext$data.stickyHeadVisible,
      stickyColumns = _useContext$data.stickyColumns,
      stickyLeftColumnVisible = _useContext$data.stickyLeftColumnVisible,
      stickyRightColumnVisible = _useContext$data.stickyRightColumnVisible;

  var _useContext2 = useContext(TableSectionContext),
      section = _useContext2.data.section;

  var isHeader = section === TABLE_HEAD;
  var isFooter = section === TABLE_FOOT;
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      isHeader: isHeader,
      isFooter: isFooter
    }),
    cellsProps: {
      isHeader: isHeader,
      isFooter: isFooter,
      stickyTop: enableStickyTop ? !!stickyHead && isHeader : false,
      stickyColumns: enableStickyColumns ? stickyColumns : EMPTY_STICKY_COLUMNS,
      stickyTopVisible: !!stickyHeadVisible && isHeader,
      stickyLeftColumnVisible: stickyLeftColumnVisible,
      stickyRightColumnVisible: stickyRightColumnVisible
    }
  };
};